<div class="incident-report-container" *transloco="let t; prefix: 'accidents'">
  <div class="table-container">
    <div class="table-inner">
      @if (isLoading) {
        <div class="loading-overlay">
          <span class="spinner-border"></span>
        </div>
      } @else if (hasError) {
        <div class="state-overlay">
          <app-error-state></app-error-state>
        </div>
      } @else if (!rows.length) {
        <div class="state-overlay">
          <app-empty-state></app-empty-state>
        </div>
      }

      <table class="incident-reports-table" [class.table-page-full]="rows.length === pageSize">
        <thead>
          <tr>
            <th class="asset">{{ t('incidentReport.table.asset') }}</th>
            <th class="driver">{{ t('incidentReport.table.driver') }}</th>
            <th class="date-time">{{ t('incidentReport.table.dateAndTime') }}</th>
            <th class="incident-type">{{ t('incidentReport.table.incidentType') }}</th>
            <th class="location">{{ t('incidentReport.table.location') }}</th>
            <th class="attachments">{{ t('incidentReport.table.attachments') }}</th>
            <th class="description">{{ t('incidentReport.table.description') }}</th>
            <th class="severity">{{ t('incidentReport.table.severity') }}</th>
            <th class="actions">{{ t('incidentReport.table.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @if(!isLoading && !hasError) {
            @for(report of rows; track report.incidentId) {
              <tr class="incident-report-row">
                <td class="asset"><span class="cell-text">{{ report.assetName }}</span></td>
                <td class="driver"><span class="cell-text">{{ report.driverInvolved }}</span></td>
                <td class="date-time"><span class="cell-text cell-text--single">{{ report.occurredAt | date: dateTimeFormat }}</span></td>
                <td class="incident-type"><span class="cell-text">{{ report.localizedIncidentType || report.incidentType }}</span></td>
                <td class="location">
                  <button type="button" class="location-link" [title]="report.location" (click)="onViewLocation(report)">
                    <span class="cell-text">{{ report.location }}</span>
                  </button>
                </td>
                <td class="attachments">
                  <app-attachments-pill
                    [count]="report.attachmentCount"
                    (pillClick)="onViewAttachments(report)">
                  </app-attachments-pill>
                </td>
                <td class="description"><span class="cell-text" [title]="report.description || emptyValue">{{ report.description || emptyValue }}</span></td>
                <td class="severity">
                  <span class="severity-badge" [ngClass]="getSeverityClass(report.severityType)">
                    @if(normalizeSeverity(report.severityType) === incidentSeverity.LowImpact) {
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z" fill="#50AD41"/>
                      </svg>
                    } @else if(normalizeSeverity(report.severityType) === incidentSeverity.MediumImpact) {
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM10.194 11.1367L7.33203 8.2747V3.9987H8.66536V7.7227L11.1367 10.194L10.194 11.1367Z" fill="#F4BC2B"/>
                      </svg>
                    } @else if(normalizeSeverity(report.severityType) === incidentSeverity.HighImpact) {
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.96736 1.33203C4.3087 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6607 1.33203 7.96736 1.33203ZM8.66536 11.332H7.33203V9.9987H8.66536V11.332ZM8.66536 8.66536H7.33203V4.66536H8.66536V8.66536Z" fill="#FF7F00"/>
                      </svg>
                    }
                    <span>{{ getSeverityLabelKey(report.severityType) | transloco }}</span>
                  </span>
                </td>
                <td class="actions">
                  <span ngbDropdown class="actions-dropdown" [autoClose]="true" placement="bottom-end" container="body">
                    <button type="button" class="btn actions-btn" ngbDropdownToggle>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.9987 5.83203C6.35703 5.83203 5.83203 6.35703 5.83203 6.9987C5.83203 7.64036 6.35703 8.16536 6.9987 8.16536C7.64036 8.16536 8.16536 7.64036 8.16536 6.9987C8.16536 6.35703 7.64036 5.83203 6.9987 5.83203ZM6.9987 2.33203C6.35703 2.33203 5.83203 2.85703 5.83203 3.4987C5.83203 4.14036 6.35703 4.66536 6.9987 4.66536C7.64036 4.66536 8.16536 4.14036 8.16536 3.4987C8.16536 2.85703 7.64036 2.33203 6.9987 2.33203ZM6.9987 9.33203C6.35703 9.33203 5.83203 9.85703 5.83203 10.4987C5.83203 11.1404 6.35703 11.6654 6.9987 11.6654C7.64036 11.6654 8.16536 11.1404 8.16536 10.4987C8.16536 9.85703 7.64036 9.33203 6.9987 9.33203Z" fill="#9FA1A4"/>
                      </svg>
                    </button>
                    <div ngbDropdownMenu class="incident-actions-menu">
                      <button class="dropdown-item" (click)="onEdit(report)" ngbDropdownItem>{{ t('incidentReport.edit') }}</button>
                      <button class="dropdown-item" (click)="onClaimInsurance(report)" ngbDropdownItem>{{ t('incidentReport.fileInsuranceClaim') }}</button>
                    </div>
                  </span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="table-footer d-flex justify-content-between align-items-center">
      <p class="pagination-text">
        {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
      </p>

      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="page"
        (pageChange)="goToPage($event)">
      </app-pagination>

      <span ngbDropdown #exportDropdown="ngbDropdown" class="export-dropdown" [autoClose]="true" placement="top-end" container="body">
        <button
          class="btn export-btn d-flex align-items-center gap-2"
          type="button"
          ngbDropdownToggle
          [disabled]="isLoading || isExporting || !hasDateRange">
          @if (isExporting) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          <span class="text">{{ isExporting ? t('incidentReport.exporting') : t('actions.export') }}</span>
          @if (!isExporting) {
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.41797 9.33463H7.58464V4.08464H9.33464L7.0013 1.16797L4.66797 4.08464H6.41797V9.33463Z" fill="#4D4749"/>
              <path d="M2.91667 12.8333H11.0833C11.7267 12.8333 12.25 12.3101 12.25 11.6667V6.41667C12.25 5.77325 11.7267 5.25 11.0833 5.25H8.75V6.41667H11.0833V11.6667H2.91667V6.41667H5.25V5.25H2.91667C2.27325 5.25 1.75 5.77325 1.75 6.41667V11.6667C1.75 12.3101 2.27325 12.8333 2.91667 12.8333Z" fill="#4D4749"/>
            </svg>
          }
        </button>
        <div ngbDropdownMenu class="incident-export-menu">
          <button type="button" class="dropdown-item" (click)="onExport('pdf'); exportDropdown.close()" ngbDropdownItem>{{ t('incidentReport.exportAsPdf') }}</button>
          <button type="button" class="dropdown-item" (click)="onExport('xlsx'); exportDropdown.close()" ngbDropdownItem>{{ t('incidentReport.exportAsExcel') }}</button>
          <button type="button" class="dropdown-item" (click)="onExport('csv'); exportDropdown.close()" ngbDropdownItem>{{ t('incidentReport.exportAsCsv') }}</button>
        </div>
      </span>
    </div>
  </div>
</div>